import Alert from "@mui/material/Alert";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import "../../styles/AppScreen.css";

export default function SampleDataBanner({ onChatClick }) {
  return (
    <Alert
      className="sample-data-banner"
      icon={<InfoOutlinedIcon fontSize="inherit" />}
      severity="info"
      variant="outlined"
      aria-label="Preview notice: this page is showing sample data"
    >
      While we continue <strong>building out this dashboard</strong>, feel free to <strong>explore our agents</strong>.
      {onChatClick && (
        <button
          type="button"
          className="sample-data-banner-btn"
          onClick={onChatClick}
        >
          Chat with Agent
        </button>
      )}
    </Alert>
  );
}
